import { useEffect, useState } from 'react';
import styles from './Index.module.css';
import { ShowFadeHidden } from '../../ShowFadeHidden';
import { ShowFadeLeftRightSection } from '../../ShowFadeLeftRightSection';
import { ShowFadeRightLeftSection } from '../../ShowFadeRightLeftSection';
import { ShowFadeInUpSection } from '../../ShowFadeInUpSection';
export const Duvidas = () => {
    const [state, setState] = useState(false);
    useEffect(() => {
        if (!state) {
            setState(true);
            return;
        }

        ShowFadeInUpSection(styles.ContainerExterno);
        {///Animação das mensagens
            {//esconder mensagens
                ShowFadeHidden('anim-left-right-BannerDuvidas-1');
                ShowFadeHidden('anim-left-right-BannerTextos-1');
            }
            {//execução em cascata
                const time = .5;//meio segundo de uma para outra
                ShowFadeLeftRightSection('anim-left-right-BannerDuvidas-1', time, () => {
                    ShowFadeRightLeftSection('anim-left-right-BannerTextos-1', time, () => {
                    });
                });
            }
        }  ///
    }, [state])

    const scrollToFac = () => {
        const js_container_fac = document.getElementById('js_container_fac');
        if (!js_container_fac) { return }
        const offset = 100; // pixels a subtrair
        const elementPosition = js_container_fac.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
    return <div className={styles.ContainerExterno}>
        <div className={styles.Container}>

            <img
                className={`${styles.BannerDuvidas} anim-left-right-BannerDuvidas-1`}
                src={require('./t11.png')}
                loading='lazy'
                alt='Banner no formato desenho de um jovem no mercado com dúvidas.'
            />
            <div className={`${styles.BannerTextos} anim-left-right-BannerTextos-1`} >
                <p >Ficou alguma dúvida?</p>
                <div id="js_link_container_fac">
                    <u className='GLOBAL_PC_MOUSE_HOVER' onClick={scrollToFac}>
                        Ir para as perguntas frequêntes
                    </u>
                </div>
            </div>
        </div>
    </div>
}